<template>
  <div>
    <div style="padding: 0 10px">
      <van-row
        type="flex"
        justify="center"
        style="
          height: 30px;
          line-height: 30px;
          font-weight: 600;
          background-color: #01B198;
          color: rgb(255, 255, 255);
          font-size: 14px;
          text-align: center;
        "
        class="OneTie OneTieactive"
      >
        <van-col span="12" style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
          >Sell in
        </van-col>
        <van-col span="12"> Sell out </van-col>
      </van-row>

      <div class="box" v-for="(item, i) in tableList" :key="i">
        <van-row
          type="flex"
          justify="center"
          class="OneTie active OneTieactive"
          @click.prevent="showList($event)"
        >
          <van-col span="2">
            <div class="red">
              <img src="../../../assets/jpg/icon-1-down.svg" alt />
            </div>
          </van-col>

          <van-col span="20">
            <van-row>
              <van-col span="24">
                <div class="title">
                  {{ item.brandCd }}
                </div>
              </van-col>
            </van-row>

            <van-row>
              <van-col span="7">
                <div class="proBoxsLeft">
                  <div class="tableLeft progressBox">
                    <div class="tabMid">
                      <b :class="item.inClass11">{{
                        item.SELLIN_SALES_VALUE | NumFormat
                      }}</b>
                    </div>
                    <div
                      class="progress"
                      style="display: flex; flex-direction: column"
                    >
                      <span>
                        <p
                          :class="item.inClass1"
                          :style="'width:' + item.inWidth1"
                        >
                          {{
                            item.SELLIN_SALES_VALUE == 0 ||
                            item.SELLIN_TARGET_VALUE1 == 0
                              ? 0 + "%"
                              : (
                                  (item.SELLIN_SALES_VALUE /
                                    item.SELLIN_TARGET_VALUE1) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>

                      <!-- <div class="textTitle">VS RBP</div> -->
                    </div>
                    <!-- <div
                      class="progress"
                      style="display: flex; flex-direction: column"
                    >
                      <span>
                        <p
                          :class="item.inClass2"
                          :style="'width:' + item.inWidth2"
                        >
                          {{
                            item.SELLIN_SALES_VALUE == 0 ||
                            item.SELLIN_TARGET_VALUE2 == 0
                              ? "0%"
                              : (
                                  (item.SELLIN_SALES_VALUE /
                                    item.SELLIN_TARGET_VALUE2) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>

                      <div class="textTitle">VS MMF</div>
                    </div> -->
                  </div>
                </div>
              </van-col>

              <van-col span="3">
                <div
                  class="tableRight middleContentCenter"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="rightFlex">
                    <span>{{ item.SELLIN_TARGET_VALUE1 | NumFormat }}</span>
                  </div>
                  <!-- <div class="rightFlex">
                    <span>{{ item.SELLIN_TARGET_VALUE2 | NumFormat }}</span>
                  </div> -->

                  <div class="rightFlex">
                    <span>{{ item.SELLIN_BTG1 | NumFormat }}</span>
                  </div>

                  <div class="rightFlex">
                    <span
                      >{{
                        (weekPatternFlag == true
                          ? item.weekPattern * 100
                          : item.timeGone * 100) | NumFormat
                      }}%</span
                    >
                  </div>

                  <!-- <div class="rightFlex">
                    <span>{{ item.SELLIN_BTG2 | NumFormat }}</span>
                  </div> -->

                  <!-- <div class="rightFlex vsProgress">
                    <span>
                      <p
                        :class="
                          parseFloat(item.SELLIN_VS_LY) <
                            typeValue.timeGone * 100 &&
                          parseFloat(item.SELLIN_VS_LY) >
                            typeValue.timeGone * 100 - 5
                            ? 'pinCol'
                            : parseFloat(item.SELLIN_VS_LY) >=
                              typeValue.timeGone * 100
                            ? 'helthyCol'
                            : 'noticeCol'
                        "
                        :style="
                          'width:' +
                          (parseFloat(item.SELLIN_VS_LY) >= 100
                            ? '97%'
                            : item.SELLIN_VS_LY)
                        "
                      >
                        {{
                          item.SELLIN_VS_LY == "" ? 0 + "%" : item.SELLIN_VS_LY
                        }}
                      </p>
                    </span>
                  </div> -->
                </div>
              </van-col>

              <van-col span="4">
                <div
                  class="tableCenter middleContentCenter"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="centerFlex">{{ type1 }}</div>
                  <!-- <div class="centerFlex">{{ type2 }}</div> -->
                  <div class="centerFlex">{{ type3 }}</div>
                  <!-- <div class="centerFlex">{{ type4 }}</div> -->

                  <!-- <div class="centerFlex" style="visibility:hidden">
                    vs.LY
                  </div> -->
                  <div class="centerFlex">{{ type5 }}</div>
                </div>
              </van-col>

              <van-col span="3">
                <div class="tableLeft">
                  <div class="leftFlex middleContentCenter">
                    <span>
                      {{ item.SELLOUT_TARGET_VALUE1 | NumFormat }}
                    </span>
                  </div>

                  <!-- <div class="leftFlex">
                    <span>
                      {{ item.SELLOUT_TARGET_VALUE2 | NumFormat }}
                    </span>
                  </div> -->

                  <div class="leftFlex">
                    <span>
                      {{ item.SELLOUT_BTG1 | NumFormat }}
                    </span>
                  </div>

                  <div class="leftFlex">
                    <span
                      >{{
                        (weekPatternFlag == true
                          ? item.weekPatternSellout * 100
                          : item.timeGoneSellout * 100) | NumFormat
                      }}%</span
                    >
                  </div>

                  <!-- <div class="leftFlex">
                    <span>
                      {{ item.SELLOUT_BTG2 | NumFormat }}
                    </span>
                  </div> -->

                  <!-- <div class="leftFlex vsProgress">
                    <span>
                      <p
                        :class="
                          parseFloat(item.SELLOUT_VS_LY) <
                            typeValue.timeGoneSellout * 100 &&
                          parseFloat(item.SELLOUT_VS_LY) >
                            typeValue.timeGoneSellout * 100 - 5
                            ? 'pinCol'
                            : parseFloat(item.SELLOUT_VS_LY) >=
                              typeValue.timeGoneSellout * 100
                            ? 'helthyCol'
                            : 'noticeCol'
                        "
                        :style="
                          'width:' +
                          (parseFloat(item.SELLOUT_VS_LY) >= 100
                            ? '97%'
                            : item.SELLOUT_VS_LY)
                        "
                      >
                        {{
                          item.SELLOUT_VS_LY == ""
                            ? 0 + "%"
                            : item.SELLOUT_VS_LY
                        }}
                      </p>
                    </span>
                  </div> -->
                </div>
              </van-col>

              <van-col span="7">
                <div class="proBoxsRight">
                  <div class="tableLeft progressBox">
                    <div class="tabMid">
                      <b :class="item.outClass11">
                        {{ item.SELLOUT_SALES_VALUE | NumFormat }}
                      </b>
                    </div>
                    <div
                      class="progress"
                      style="display: flex; flex-direction: column"
                    >
                      <span>
                        <p
                          :class="item.outClass1"
                          :style="'width:' + item.outWidth1"
                        >
                          {{
                            item.SELLOUT_SALES_VALUE == 0 ||
                            item.SELLOUT_TARGET_VALUE1 == 0
                              ? "0%"
                              : (
                                  (item.SELLOUT_SALES_VALUE /
                                    item.SELLOUT_TARGET_VALUE1) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>

                      <!-- <div class="textTitle">VS RBP</div> -->
                    </div>

                    <!-- <div
                      class="progress"
                      style="display: flex; flex-direction: column"
                    >
                      <span>
                        <p
                          :class="item.outClass2"
                          :style="'width:' + item.outWidth2"
                        >
                          {{
                            item.SELLOUT_SALES_VALUE == 0 ||
                            item.SELLOUT_TARGET_VALUE2 == 0
                              ? "0%"
                              : (
                                  (item.SELLOUT_SALES_VALUE /
                                    item.SELLOUT_TARGET_VALUE2) *
                                  100
                                ).toFixed(1) + "%"
                          }}
                        </p>
                      </span>

                      <div class="textTitle">VS MMF</div>
                    </div> -->
                  </div>
                </div>
              </van-col>
            </van-row>
          </van-col>

          <van-col span="2"> </van-col>
        </van-row>

        <!-- levelList2 -->
        <!-- levelList2ByBu -->
        <div
          v-show="isShow"
          v-for="item1 in item.levelList2ByBu"
          :key="item1.level1"
        >
          <van-row
            type="flex"
            @click.prevent="show($event)"
            justify="center"
            class="OneTie TwoTieactive"
          >
            <van-col span="2">
              <div v-show="item1.levelList3.length > 0" class="red">
                <img src="../../../assets/jpg/icon-2-right.svg" alt />
              </div>
            </van-col>

            <van-col span="20">
              <van-row>
                <van-col span="24">
                  <div class="title">
                    {{ item1.level1 }}
                  </div>
                </van-col>
              </van-row>

              <van-row>
                <van-col span="7">
                  <div class="proBoxsLeft">
                    <div class="tableLeft progressBox">
                      <div class="tabMid">
                        <b :class="item1.inClass11">
                          {{ item1.SELLIN_SALES_VALUE | NumFormat }}
                        </b>
                      </div>

                      <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="item1.inClass1"
                            :style="'width:' + item1.inWidth1"
                          >
                            {{
                              item1.SELLIN_SALES_VALUE == 0 ||
                              item1.SELLIN_TARGET_VALUE1 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLIN_SALES_VALUE /
                                      item1.SELLIN_TARGET_VALUE1) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                        <!-- <div class="textTitle">VS RBP</div> -->
                      </div>
                      <!-- <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="item1.inClass2"
                            :style="'width:' + item1.inWidth2"
                          >
                            {{
                              item1.SELLIN_SALES_VALUE == 0 ||
                              item1.SELLIN_TARGET_VALUE2 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLIN_SALES_VALUE /
                                      item1.SELLIN_TARGET_VALUE2) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                        <div class="textTitle">VS MMF</div>
                      </div> -->
                    </div>
                  </div>
                </van-col>

                <van-col span="3">
                  <div
                    class="tableRight middleContentCenter"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="rightFlex">
                      <span>{{ item1.SELLIN_TARGET_VALUE1 | NumFormat }}</span>
                    </div>

                    <!-- <div class="rightFlex">
                      <span>{{ item1.SELLIN_TARGET_VALUE2 | NumFormat }}</span>
                    </div> -->

                    <div class="rightFlex">
                      <span>{{ item1.SELLIN_BTG1 | NumFormat }}</span>
                    </div>

                    <div class="rightFlex">
                      <span
                        >{{
                          (weekPatternFlag == true
                            ? item1.weekPattern * 100
                            : item1.timeGone * 100) | NumFormat
                        }}%</span
                      >
                    </div>

                    <!-- <div class="rightFlex">
                      <span>{{ item1.SELLIN_BTG2 | NumFormat }}</span>
                    </div> -->

                    <!-- <div class="rightFlex vsProgress">
                      <span>
                        <p
                          :class="
                            parseFloat(item1.SELLIN_VS_LY) <
                              typeValue.timeGone * 100 &&
                            parseFloat(item1.SELLIN_VS_LY) >
                              typeValue.timeGone * 100 - 5
                              ? 'pinCol'
                              : parseFloat(item1.SELLIN_VS_LY) >=
                                typeValue.timeGone * 100
                              ? 'helthyCol'
                              : 'noticeCol'
                          "
                          :style="
                            'width:' +
                            (parseFloat(item1.SELLIN_VS_LY) >= 100
                              ? '97%'
                              : item1.SELLIN_VS_LY)
                          "
                        >
                          {{
                            item1.SELLIN_VS_LY == "" ? "0%" : item1.SELLIN_VS_LY
                          }}
                        </p>
                      </span>
                    </div> -->
                  </div>
                </van-col>

                <van-col span="4">
                  <div
                    class="tableCenter middleContentCenter"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="centerFlex">{{ type1 }}</div>
                    <!-- <div class="centerFlex">{{ type2 }}</div> -->
                    <div class="centerFlex">{{ type3 }}</div>
                    <!-- <div class="centerFlex">{{ type4 }}</div> -->

                    <!-- <div class="centerFlex" style="visibility:hidden">
                      vs.LY
                    </div> -->
                    <div class="centerFlex">{{ type5 }}</div>
                  </div>
                </van-col>

                <van-col span="3">
                  <div class="tableLeft middleContentCenter">
                    <div class="leftFlex">
                      <span>{{ item1.SELLOUT_TARGET_VALUE1 | NumFormat }}</span>
                    </div>
                    <!-- <div class="leftFlex">
                      <span>{{ item1.SELLOUT_TARGET_VALUE2 | NumFormat }}</span>
                    </div> -->

                    <div class="leftFlex">
                      <span>{{ item1.SELLOUT_BTG1 | NumFormat }}</span>
                    </div>


                    <div class="leftFlex">
                      <span
                        >{{
                          (weekPatternFlag == true
                            ? item.weekPatternSellout * 100
                            : item.timeGoneSellout * 100) | NumFormat
                        }}%</span
                      >
                    </div>

                    <!-- <div class="leftFlex">
                      <span>{{ item1.SELLOUT_BTG2 | NumFormat }}</span>
                    </div> -->

                    <!-- <div class="leftFlex vsProgress">
                      <span>
                        <p
                          :class="
                            parseFloat(item1.SELLOUT_VS_LY) <
                              typeValue.timeGoneSellout * 100 &&
                            parseFloat(item1.SELLOUT_VS_LY) >
                              typeValue.timeGoneSellout * 100 - 5
                              ? 'pinCol'
                              : parseFloat(item1.SELLOUT_VS_LY) >=
                                typeValue.timeGoneSellout * 100
                              ? 'helthyCol'
                              : 'noticeCol'
                          "
                          :style="
                            'width:' +
                            (parseFloat(item1.SELLOUT_VS_LY) >= 100
                              ? '97%'
                              : item1.SELLOUT_VS_LY)
                          "
                        >
                          {{
                            item1.SELLOUT_VS_LY == ""
                              ? 0 + "%"
                              : item1.SELLOUT_VS_LY
                          }}
                        </p>
                      </span>
                    </div> -->
                  </div>
                </van-col>

                <van-col span="7">
                  <div class="proBoxsRight">
                    <div class="tableLeft progressBox">
                      <div class="tabMid">
                        <b :class="item1.outClass11">
                          {{ item1.SELLOUT_SALES_VALUE | NumFormat }}
                        </b>
                      </div>

                      <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="item1.outClass1"
                            :style="'width:' + item1.outWidth1"
                          >
                            {{
                              item1.SELLOUT_SALES_VALUE == 0 ||
                              item1.SELLOUT_TARGET_VALUE1 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLOUT_SALES_VALUE /
                                      item1.SELLOUT_TARGET_VALUE1) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>

                        <!-- <div class="textTitle">VS RBP</div> -->
                      </div>

                      <!-- <div
                        class="progress"
                        style="display: flex; flex-direction: column"
                      >
                        <span>
                          <p
                            :class="item1.outClass2"
                            :style="'width:' + item1.outWidth2"
                          >
                            {{
                              item1.SELLOUT_SALES_VALUE == 0 ||
                              item1.SELLOUT_TARGET_VALUE2 == 0
                                ? 0 + "%"
                                : (
                                    (item1.SELLOUT_SALES_VALUE /
                                      item1.SELLOUT_TARGET_VALUE2) *
                                    100
                                  ).toFixed(1) + "%"
                            }}
                          </p>
                        </span>
                        <div class="textTitle">VS MMF</div>
                      </div> -->
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-col>

            <van-col span="2"> </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";

export default {
  data() {
    return {
      type1: "",
      type2: "",
      type3: "",
      type4: "",
      type5: "",
      typeValue: {},

      tableList: [],
      isShow: false,
      isShow2: false,
      achVing: sessionStorage.getItem("achVing"),
      type: "",

      weekPatternFlag: false,
    };
  },
  methods: {
    getWidthPercent(value) {
      if ((value * 100).toFixed(1) >= 100) {
        return "97%";
      } else {
        return (value * 100).toFixed(1) + "%";
      }
    },

    getDataClass(a, b, c) {
      if (b !== 0) {
        if (a / b > 1) {
          return "helthy"; //绿色
        } else if (a / b < 0.8) {
          return "notice"; //红色
        } else {
          return "pin"; //黄色
        }
      } else {
        if (a / c > 1) {
          return "helthy"; //绿色
        } else if (a / c < 0.8) {
          return "notice"; //红色
        } else {
          return "pin"; //黄色
        }
      }
    },

    getDataClassTitle(a, b, c) {
      if (b !== 0) {
        if (a / b > 1) {
          return "helthyFormat"; //绿色
        } else if (a / b < 0.8) {
          return "noticeFormat"; //红色
        } else {
          return "pinFormat"; //黄色
        }
      } else {
        if (a / c > 1) {
          return "helthyFormat"; //绿色
        } else if (a / c < 0.8) {
          return "noticeFormat"; //红色
        } else {
          return "pinFormat"; //黄色
        }
      }
    },

    getList() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getBuByList")
        .get("sellinAndsellout/getBuByListSellInAndSellOut")
        .then((res) => {
          this.achVing = 0;
          this.achVing = parseFloat(sessionStorage.getItem("achVing"));

          res.data.data.forEach((item) => {
            item.inWidth1 = this.getWidthPercent(
              item.SELLIN_TARGET_VALUE1_ACHEVE
            );

            item.inWidth2 = this.getWidthPercent(
              item.SELLIN_TARGET_VALUE2_ACHEVE
            );

            item.outWidth1 = this.getWidthPercent(
              item.SELLOUT_TARGET_VALUE1_ACHEVE
            );

            item.outWidth2 = this.getWidthPercent(
              item.SELLOUT_TARGET_VALUE2_ACHEVE
            );

            // 背景颜色
            item.inClass1 = this.getDataClass(
              item.SELLIN_TARGET_VALUE1_ACHEVE,
              item.weekPattern,
              item.timeGone
            );

            item.inClass2 = this.getDataClass(
              item.SELLIN_TARGET_VALUE2_ACHEVE,
              item.weekPattern,
              item.timeGone
            );

            item.outClass1 = this.getDataClass(
              item.SELLOUT_TARGET_VALUE1_ACHEVE,
              item.weekPatternSellout,
              item.timeGoneSellout
            );

            item.outClass2 = this.getDataClass(
              item.SELLOUT_TARGET_VALUE2_ACHEVE,
              item.weekPatternSellout,
              item.timeGoneSellout
            );

            // 颜色

            item.inClass11 = this.getDataClassTitle(
              item.SELLIN_TARGET_VALUE1_ACHEVE,
              item.weekPattern,
              item.timeGone
            );

            item.outClass11 = this.getDataClassTitle(
              item.SELLOUT_TARGET_VALUE1_ACHEVE,
              item.weekPatternSellout,
              item.timeGoneSellout
            );

            item.levelList2ByBu.forEach((item1) => {
              item1.inWidth1 = this.getWidthPercent(
                item1.SELLIN_TARGET_VALUE1_ACHEVE
              );

              item1.inWidth2 = this.getWidthPercent(
                item1.SELLIN_TARGET_VALUE2_ACHEVE
              );

              item1.outWidth1 = this.getWidthPercent(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE
              );

              item1.outWidth2 = this.getWidthPercent(
                item1.SELLOUT_TARGET_VALUE2_ACHEVE
              );

              // 背景颜色
              item1.inClass1 = this.getDataClass(
                item1.SELLIN_TARGET_VALUE1_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.inClass2 = this.getDataClass(
                item1.SELLIN_TARGET_VALUE2_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.outClass1 = this.getDataClass(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );

              item1.outClass2 = this.getDataClass(
                item1.SELLOUT_TARGET_VALUE2_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );

              // 颜色
              item1.inClass11 = this.getDataClassTitle(
                item1.SELLIN_TARGET_VALUE1_ACHEVE,
                item1.weekPattern,
                item1.timeGone
              );

              item1.outClass11 = this.getDataClassTitle(
                item1.SELLOUT_TARGET_VALUE1_ACHEVE,
                item1.weekPatternSellout,
                item1.timeGoneSellout
              );
            });
          });

          this.tableList = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getType() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        .get("sellinAndsellout/getTargetTypeSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            let resultData = res.data.data[0];
            this.type1 = resultData.SELLOUT_TARGETTYPE1;
            this.type2 = resultData.SELLOUT_TARGETTYPE2;

            this.type3 = resultData.SELLOUT_TARGETTYPE_BTG1;
            this.type4 = resultData.SELLOUT_TARGETTYPE_BTG2;
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },

    getTypeData() {
      this.$addr
        .get("sellinAndsellout/getSumDataSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            this.typeValue = res.data.data[0];

            if (
              this.typeValue.weekPattern 
            ) {
              // Weekly Pattern
              this.weekPatternFlag = true;
              this.type5 = "pattern";
            } else {
              // Time Gone
              this.weekPatternFlag = false;
              this.type5 = "Time Gone";
            }
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },

    show(e) {
      console.log($(e.currentTarget).find(".red"));
      if ($(e.currentTarget).find(".red").attr("class") == "red") {
        $(e.currentTarget).find(".red").addClass("redPlusActive");
      } else {
        $(e.currentTarget).find(".red").removeClass("redPlusActive");
      }

      $(e.currentTarget).stop().nextAll(".TwoTie").slideToggle(500);
      $(e.currentTarget).stop().nextAll(".Map").slideToggle(500);
    },
    showList(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red") {
        $(e.currentTarget).find(".red").addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget).find(".red").removeClass("redPlusActiveImg");
      }

      $(e.currentTarget).stop().nextAll().slideToggle(500);
    },
  },
  created() {
    this.getList();
    this.getType();

    this.getTypeData();
  },
};
</script>
<style scoped>
.OneTieactive {
  width: 104%;
  margin-left: -9px;
  background: #B1E0DA;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  font-size: 12px;
}
.TwoTieactive {
  background: #D3ECE685;
}
.TwoTieAct {
  background: #ffffff;
  margin-bottom: 8px;
  width: 96%;
  border-radius: 10px;
  margin-left: 7px;
}
.red {
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 100%;
}
.red img {
  width: 30px;
  height: 30px;
}
.LittleBut {
  height: 20px;
  width: 20px;
  text-align: center;
  background: rgba(158, 131, 108, 0.3);
  border-radius: 50%;
  line-height: 20px;
}
.notice {
  background: #c7544d !important;
}
.noticeCol {
  background: #f9c6bd !important;
}
.noticeFormat {
  color: #c7544d !important;
}
.helthyFormat {
  color: #84a05f !important;
}
.pinFormat {
  color: #e9c978 !important;
}
.helthyCol {
  background: #d4e1b4 !important;
}
.pinCol {
  background: #e0c681 !important;
}
.helthy {
  background: #84a05f !important;
}
.pin {
  background: #f3d480 !important;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list b {
  text-align: right;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  height: 37px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.list span {
  text-align: left;
  font-family: "微软雅黑" !important;
  height: 37px;
  min-width: 50px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.tableLeft {
  /* padding: 12px 5px 13px 22px; */
  display: flex;
  justify-content: space-around;
  /* align-items: center; */
  flex-direction: column;
  /* min-height: 45px; */
}

.tableLeft .tabMid {
  display: flex;
  justify-content: left;
  margin-bottom: 6px;
}

.tableLeft .tableTop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tableLeft .tableTop span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #3a3a3b;
  white-space: nowrap;
}

.tableLeft .tableTop b {
  font-family: "微软雅黑" !important;
  font-size: 14px;
}
.TwoTie .progress {
  width: 90.2%;
}

.tableLeft .leftFlex span {
  padding-left: 4px;
  position: relative;
  height: 20px;
  line-height: 20px;
  width: 100%;
  display: flex;
  justify-content: left;
  color: #4f4779;
  font-weight: 600;

  font-family: "微软雅黑" !important;
  font-size: 12px;
}

.tableCenter .centerFlex {
  line-height: 20px;
  height: 20px;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.TwoTie .tableLeft .tableTop span {
  overflow: hidden;
  white-space: nowrap;
}
.progress {
  /* margin: 6px 0px; */
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.progress span {
  /* width: 70%; */
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 12px;
}

.progress label {
  font-size: 6px;
  white-space: nowrap;
  margin: 2px;
}

.textTitle {
  font-size: 8px;
  white-space: nowrap;

  margin: 4px 0;
}

.vsProgress span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 14px;
  line-height: 20px;
  box-sizing: border-box;
  margin-right: 5px;
  margin-top: 3px;
}

.progressData span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 12px;
}

.progressData span p {
  display: block;
  width: 50%;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #3a3a3b;
  line-height: 12px;
  border-radius: 5px;
  text-align: right;
  padding-right: 6px;
}

.progress span p {
  display: block;
  width: 50%;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #f6f6ff;
  line-height: 14px;
  border-radius: 5px;
  text-align: right;
  /* padding-right: 6px; */
}

.vsProgress span p {
  display: block;
  width: 50%;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #4f4779;
  line-height: 14px;
  border-radius: 5px;
  text-align: right;
  padding-right: 6px;
}
.tableLeft span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #3a3a3b;
}
.tableLeft b {
  font-family: "微软雅黑" !important;
  font-size: 15px;
  color: #84a05f;
}
.tableRight {
  padding: auto 4px;
  /* margin: 12px 0 0 4px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.proBoxsLeft {
  display: flex;
  justify-content: left;
  align-items: center;
  /* margin-top: 10px; */
}

.proBoxsRight {
  display: flex;
  justify-content: right;
  align-items: center;
  /* margin-top: 10px; */
}

.title {
  font-weight: 700;
  margin: 0px 0px 8px 0px;

  display: flex;
  justify-content: left;
}

.progressBox {
  width: 86%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px -1px rgba(90, 66, 37, 0.5);
  padding: 5px 6px;
  box-sizing: border-box;
}

.tableRight .rightFlex {
  min-width: 60px;
  font-weight: 600;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
  height: 20px;
  line-height: 20px;
  display: flex;
  justify-content: right;
}

.tableRight .rightFlex span {
  /* min-width: 60px; */
  font-family: "微软雅黑" !important;
  font-size: 12px;
  font-weight: 600;
  color: #4f4779;
  text-align: right;

  display: flex;
  justify-content: end;
  /* border: 1px solid red; */
  margin-right: 14px;
}

.tableRight .rightFlex b {
  text-align: left;
  min-width: 50px;

  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #332a66;
}
.tableRight .rightFlex i {
  font-style: normal;
  text-align: left;
  min-width: 60px;

  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
}
.tableRight .rightFlex img {
  position: absolute;
  width: 12px;
  height: 12px;
  left: 8px;
  top: -1px;
}
.box {
  margin: 1.5px auto 0;
  padding: 0 14px;
  position: relative;
}
.OneTie {
  position: relative;

  margin-left: 5px;
  width: 97%;
  height: 100px;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  /* line-height: 17px; */
  /* text-align: right;
  text-align: center; */
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #000000;
  z-index: 999;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.active {
  width: 103%;
  margin-left: -7px;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  font-size: 12px;
}
.ly {
  margin-left: 10px;
  display: inline-block;
  width: 40px;
  height: 12px;
  line-height: 12px;
  text-align: center !important;
  border-radius: 6px;
  background: #d4e1b4;
}
.TwoTie {
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;
  width: 97%;
  height: 70px;
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  line-height: 17px;
  padding: 0 10px;
}

.middleContentCenter {
  margin-top: -5px;
}

.redPlusActive > img {
  transform: rotate(90deg);
}
.redPlusActiveImg > img {
  transform: rotate(90deg);
}
.red {
  transform: rotate(-90deg);
}
.red img {
  width: 24px;
  height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/ButSecoend/Bu/BuTable.vue